import { FC } from "react";
import { Stack } from "@mui/material";
import { TwoColsLayout } from "@vilocnv/allsetra-core";
import {
  InfoDetailContainer,
  SubscriptionInfoContainer
} from "components/sections/activationPortalSections/activationPortalSections.styled";
import { transformObjectForActivationInfoTable } from "app/data/helpers";

interface Props {
  installations?: any;
  translator: any;
}

const InnerForm: FC<Props> = ({ installations, translator }) => {
  const objectInformation =
    transformObjectForActivationInfoTable(installations);

  return (
    <Stack spacing={4} width={{ xs: "50vw", sm: "30vw" }}>
      <SubscriptionInfoContainer>
        {Object.keys(objectInformation).map((item, i) => (
          <TwoColsLayout
            title={i === 0 ? translator("titles.objectInfo") : ""}
            fullWidth
            hideDivider
            key={`${i}`}
          >
            <InfoDetailContainer>
              <h6>{item}</h6>
              <p>{objectInformation[item]}</p>
            </InfoDetailContainer>
          </TwoColsLayout>
        ))}
      </SubscriptionInfoContainer>

      <SubscriptionInfoContainer>
        <TwoColsLayout
          title={translator("titles.deviceInformation")}
          fullWidth
          hideDivider
        >
          <InfoDetailContainer>
            <h6 style={{ fontWeight: "bold" }}>
              {translator("deviceId.label", { ns: "formFieldsTranslation" })}
            </h6>
            <p>{installations?.deviceInfo?.serialNumber}</p>
          </InfoDetailContainer>
        </TwoColsLayout>
        <TwoColsLayout fullWidth hideDivider>
          <InfoDetailContainer>
            <h6>
              {translator("deviceType.label", { ns: "formFieldsTranslation" })}
            </h6>
            <p>{installations?.deviceInfo?.deviceTypeName}</p>
          </InfoDetailContainer>
        </TwoColsLayout>
      </SubscriptionInfoContainer>

      <SubscriptionInfoContainer>
        <TwoColsLayout
          title={translator("titles.serviceInformation")}
          fullWidth
          hideDivider
        >
          <InfoDetailContainer>
            <h6>
              {translator("serviceTypeName.label", {
                ns: "formFieldsTranslation"
              })}
            </h6>
            <p>{installations?.serviceInfo?.name}</p>
          </InfoDetailContainer>
        </TwoColsLayout>
        <TwoColsLayout fullWidth hideDivider>
          <InfoDetailContainer>
            <h6>
              {translator("serviceTypeDetails.label", {
                ns: "formFieldsTranslation"
              })}
            </h6>
            <p>{installations?.serviceInfo?.description}</p>
          </InfoDetailContainer>
        </TwoColsLayout>
      </SubscriptionInfoContainer>
    </Stack>
  );
};

export default InnerForm;
